module.exports = __webpack_public_path__ + "static/media/i6.a086ebf7.png";